import React from 'react';
import UpArrow from '../assets/images/UpArrow.svg';

export default () => {
  return <img src={UpArrow} alt="" />;
};
